"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTITY_TABLE_COLUMN_CREATORS = exports.entityTableLinkCountColumn = exports.entityTableDateTimeColumn = exports.entityTableDateColumn = exports.entityTableRelativeDateColumn = exports.entityTableCountColumn = exports.entityTableImageColumn = exports.entityTableUpdatedByColumn = exports.entityTableCreatedByColumn = exports.entityTableContentColumn = exports.entityTableNameColumn = exports.entityTableBooleanColumn = exports.entityTableColorColumn = exports.entityTableEntityLinkColumn = exports.entityTablePersonColumn = exports.entityTableEntityValueColumn = exports.entityTableOpenGraphColumn = exports.entityReferenceColumn = exports.entityTableLinkedColumn = exports.entityTableColumn = exports.ENTITY_TABLE_COLUMN_TITLES_BY_TYPE = exports.ENTITY_TABLE_COLUMN_WEIGHTS_BY_TYPE = exports.ENTITY_TABLE_COLUMN_WEIGHTS_BY_NAME = exports.ENTITY_COLUMN_NAME_TYPES = exports.ENTITY_TABLE_TITLES = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var open_graph_cell_1 = require("../components/entities/open-graph-cell");
var empty_cell_1 = require("../components/entities/empty-cell");
var entity_value_cell_1 = require("../components/entities/entity-value-cell");
var person_cell_1 = require("../components/entities/person-cell");
var entity_tag_list_cell_1 = require("../components/entities/entity-tag-list-cell");
var image_cell_1 = require("../components/entities/image-cell");
var count_cell_1 = require("../components/entities/count-cell");
var content_cell_1 = require("../components/entities/content-cell");
var entity_link_cell_1 = require("../components/entities/entity-link-cell");
var boolean_cell_1 = require("../components/entities/boolean-cell");
var date_cell_1 = require("../components/entities/date-cell");
var entity_name_cell_1 = require("../components/entities/entity-name-cell");
var pluralize_1 = require("pluralize");
var color_value_1 = require("../components/entities/color-value");
var entity_reference_cell_1 = require("../components/entities/entity-reference-cell");
exports.ENTITY_TABLE_TITLES = {
  image2x: "Image (2x)",
  url: "URL",
  id: "ID"
};
exports.ENTITY_COLUMN_NAME_TYPES = {
  info: 'info',
  entityValue: 'entityValue',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  linkCount: 'linkCount',
  count: 'count',
  person: 'person'
};
exports.ENTITY_TABLE_COLUMN_WEIGHTS_BY_NAME = {
  createdBy: 2,
  updatedBy: 2,
  year: 1
};
exports.ENTITY_TABLE_COLUMN_WEIGHTS_BY_TYPE = {
  info: 3,
  entityValue: 3,
  longText: 3,
  linked: 2,
  url: 3,
  email: 2,
  person: 2,
  linkedMultiple: 3,
  image: 2,
  text: 1,
  count: 0.5
};
exports.ENTITY_TABLE_COLUMN_TITLES_BY_TYPE = {
  info: "Info / Description",
  longText: "Description",
  linkCount: "# Uses"
};
var entityTableColumn = function (args) {
  var _a = args.useEntityProperty,
    useEntityProperty = _a === void 0 ? true : _a,
    _b = args.align,
    align = _b === void 0 ? "center" : _b,
    context = args.context,
    name = args.name,
    nameAlternate = args.nameAlternate,
    pad = args.pad,
    emptyContent = args.emptyContent,
    title = args.title,
    icon = args.icon,
    component = args.component,
    width = args.width,
    _c = args.weight,
    weight = _c === void 0 ? 2 : _c,
    _d = args.props,
    props = _d === void 0 ? {} : _d;
  var t = context.t,
    variant = context.variant,
    hasDetails = context.hasDetails;
  var Component = component || function (_a) {
    var value = _a.value;
    return value;
  };
  var useEmptyCell = args.useEmptyCell === undefined ? true : !!args.useEmptyCell;
  // check if this column is only visible in a certain variant.
  if (args.variant && variant !== args.variant) {
    return null;
  }
  ;
  var defaultTitle = exports.ENTITY_TABLE_TITLES[name] || (0, lodash_1.startCase)(name);
  var ret = __assign(__assign({}, args), {
    name: name,
    align: align,
    title: title ? (0, lodash_1.isString)(title) ? t(title) : title : defaultTitle,
    width: width,
    icon: icon,
    pad: pad === undefined ? "all" : pad,
    renderValue: function (_a) {
      var entity = _a.entity;
      var entityDict = entity;
      var entityValue = entity && (useEntityProperty ? entityDict[name] || nameAlternate && entityDict[nameAlternate] : entity);
      if (!useEmptyCell) {
        return react_1.default.createElement(Component, __assign({}, props, {
          hasDetails: hasDetails,
          entity: entityValue,
          value: entityValue
        }));
      }
      return entityValue ? react_1.default.createElement(Component, __assign({}, props, {
        hasDetails: hasDetails,
        entity: entityValue,
        value: entityValue
      })) : react_1.default.createElement(empty_cell_1.EmptyCell, null, emptyContent || null);
    }
  });
  return ret;
};
exports.entityTableColumn = entityTableColumn;
var entityTableLinkedColumn = function (args) {
  var title = args.title,
    entityTypeName = args.entityTypeName,
    context = args.context,
    width = args.width,
    name = args.name,
    icon = args.icon,
    component = args.component,
    _a = args.props,
    props = _a === void 0 ? {
      linkPerson: false
    } : _a,
    _b = args.align,
    align = _b === void 0 ? "center" : _b;
  var entities = context.entities,
    icons = context.icons;
  var linkedEntity = entities[entityTypeName];
  var isMulti = args.isMulti === undefined ? (0, pluralize_1.isPlural)(name) : args.isMulti;
  var defaultTitle = isMulti ? linkedEntity && linkedEntity.pluralLabel : linkedEntity && linkedEntity.label;
  var defaultIcon = icons.Entities[entityTypeName];
  var defaultComponent = isMulti ? entity_tag_list_cell_1.EntityTagListCell : linkedEntity && linkedEntity.components && linkedEntity.components.cell;
  return linkedEntity && (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    align: align,
    useEntityProperty: true,
    width: width || '40%',
    title: title || defaultTitle,
    icon: icon || defaultIcon,
    props: props,
    component: component || defaultComponent || entity_tag_list_cell_1.EntityTagListCell
  }));
};
exports.entityTableLinkedColumn = entityTableLinkedColumn;
var entityReferenceColumn = function (args) {
  var title = args.title,
    context = args.context,
    width = args.width,
    name = args.name,
    icon = args.icon,
    _a = args.props,
    props = _a === void 0 ? {
      linkPerson: false
    } : _a,
    _b = args.align,
    align = _b === void 0 ? "center" : _b;
  var entities = context.entities,
    icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    align: align,
    useEntityProperty: true,
    width: width || '40%',
    props: props,
    component: entity_reference_cell_1.EntityReferenceCell
  }));
};
exports.entityReferenceColumn = entityReferenceColumn;
var entityTableOpenGraphColumn = function (args) {
  var _a = args.title,
    title = _a === void 0 ? 'Info' : _a,
    _b = args.width,
    width = _b === void 0 ? '40%' : _b,
    context = args.context,
    hasDetails = args.hasDetails;
  var icons = context.icons;
  var icon = args.icon || icons.InfoCircle;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    icon: icon,
    hasDetails: hasDetails,
    useEntityProperty: false,
    width: width,
    name: 'info',
    title: title,
    component: open_graph_cell_1.OpenGraphCell
  }));
};
exports.entityTableOpenGraphColumn = entityTableOpenGraphColumn;
var entityTableEntityValueColumn = function (args) {
  var _a = args.title,
    title = _a === void 0 ? 'Info' : _a,
    _b = args.width,
    width = _b === void 0 ? '40%' : _b,
    context = args.context;
  var icons = context.icons;
  var icon = args.icon || icons.InfoCircle;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    icon: icon,
    useEntityProperty: false,
    width: width,
    name: 'entity-value',
    title: title,
    component: entity_value_cell_1.EntityValueCell
  }));
};
exports.entityTableEntityValueColumn = entityTableEntityValueColumn;
var entityTablePersonColumn = function (args) {
  var width = args.width,
    name = args.name,
    link = args.link,
    props = args.props;
  return (0, exports.entityTableLinkedColumn)(__assign(__assign({}, args), {
    entityTypeName: "Person",
    useEntityProperty: true,
    width: width || '40%',
    name: name || 'person',
    props: __assign(__assign({}, props), {
      linkPerson: !!link
    }),
    component: person_cell_1.PersonCell
  }));
};
exports.entityTablePersonColumn = entityTablePersonColumn;
var entityTableEntityLinkColumn = function (args) {
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    useEntityProperty: false,
    component: entity_link_cell_1.EntityLinkCell
  }));
};
exports.entityTableEntityLinkColumn = entityTableEntityLinkColumn;
var entityTableColorColumn = function (args) {
  return (0, exports.entityTableColumn)(__assign(__assign({
    title: 'Info'
  }, args), {
    useEntityProperty: false,
    component: color_value_1.ColorValue
  }));
};
exports.entityTableColorColumn = entityTableColorColumn;
var entityTableBooleanColumn = function (args) {
  var context = args.context,
    name = args.name;
  var defaultTitle = exports.ENTITY_TABLE_TITLES[name] || (0, lodash_1.startCase)(name);
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    title: args.title || "".concat(defaultTitle, "?"),
    useEntityProperty: true,
    useEmptyCell: false,
    component: boolean_cell_1.BooleanCell
  }));
};
exports.entityTableBooleanColumn = entityTableBooleanColumn;
var entityTableNameColumn = function (args) {
  var context = args.context;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    name: args.name || 'name',
    useEntityProperty: false,
    component: entity_name_cell_1.EntityNameCell
  }));
};
exports.entityTableNameColumn = entityTableNameColumn;
var entityTableContentColumn = function (args) {
  var context = args.context,
    icon = args.icon;
  var icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    useEntityProperty: true,
    icon: icon || icons.ThreeLinesCircle,
    component: content_cell_1.ContentCell
  }));
};
exports.entityTableContentColumn = entityTableContentColumn;
var entityTableCreatedByColumn = function (args) {
  var width = args.width,
    name = args.name,
    link = args.link,
    props = args.props;
  return (0, exports.entityTablePersonColumn)(__assign(__assign({}, args), {
    width: width || '25%',
    name: name || 'createdBy',
    title: args.title || 'Creator',
    props: __assign(__assign({}, props), {
      showOrganisation: true,
      linkPerson: link === undefined ? true : link
    })
  }));
};
exports.entityTableCreatedByColumn = entityTableCreatedByColumn;
var entityTableUpdatedByColumn = function (args) {
  var width = args.width,
    name = args.name,
    link = args.link,
    props = args.props;
  return (0, exports.entityTablePersonColumn)(__assign(__assign({}, args), {
    width: width || '25%',
    name: name || 'updatedBy',
    title: args.title || 'Updated By',
    props: __assign(__assign({}, props), {
      linkPerson: link === undefined ? true : link
    })
  }));
};
exports.entityTableUpdatedByColumn = entityTableUpdatedByColumn;
var entityTableImageColumn = function (args) {
  var width = args.width,
    name = args.name,
    props = args.props,
    context = args.context,
    title = args.title;
  var icons = context.icons;
  var icon = args.icon || icons.Entities.Banner;
  return (0, exports.entityTableColumn)(__assign(__assign({
    maxWidth: "175px"
  }, args), {
    useEmptyCell: false,
    useEntityProperty: true,
    icon: icon,
    width: width || '40%',
    name: name || 'image',
    props: props,
    component: image_cell_1.ImageCell
  }));
};
exports.entityTableImageColumn = entityTableImageColumn;
var entityTableCountColumn = function (args) {
  var width = args.width,
    name = args.name,
    props = args.props,
    context = args.context,
    title = args.title;
  var icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    useEntityProperty: true,
    width: width || '20%',
    name: name || 'image',
    component: count_cell_1.CountCell
  }));
};
exports.entityTableCountColumn = entityTableCountColumn;
var entityTableRelativeDateColumn = function (args) {
  var width = args.width,
    context = args.context;
  var icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    width: width || '20%',
    icon: args.icon || icons.Entities.Event,
    component: date_cell_1.DateCell,
    props: __assign({
      relative: true
    }, args.props || {})
  }));
};
exports.entityTableRelativeDateColumn = entityTableRelativeDateColumn;
var entityTableDateColumn = function (args) {
  var width = args.width,
    context = args.context;
  var icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    width: width || '20%',
    icon: args.icon || icons.Entities.Event,
    component: date_cell_1.DateCell,
    props: __assign({
      relative: false
    }, args.props || {})
  }));
};
exports.entityTableDateColumn = entityTableDateColumn;
var entityTableDateTimeColumn = function (args) {
  var width = args.width,
    context = args.context;
  var icons = context.icons;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    width: width || '20%',
    icon: args.icon || icons.Entities.Event,
    component: date_cell_1.DateCell,
    props: __assign({
      showTime: true,
      relative: false
    }, args.props || {})
  }));
};
exports.entityTableDateTimeColumn = entityTableDateTimeColumn;
var entityTableLinkCountColumn = function (args) {
  var width = args.width,
    name = args.name,
    context = args.context,
    title = args.title;
  var icons = context.icons,
    t = context.t;
  var icon = args.icon || icons.Target;
  return (0, exports.entityTableColumn)(__assign(__assign({}, args), {
    useEmptyCell: true,
    useEntityProperty: true,
    icon: icon,
    width: width || '20%',
    title: title || '# Uses',
    name: '_linkCount',
    emptyContent: t('(unused)'),
    component: count_cell_1.CountCell
  }));
};
exports.entityTableLinkCountColumn = entityTableLinkCountColumn;
exports.ENTITY_TABLE_COLUMN_CREATORS = {
  id: exports.entityTableColumn,
  file: exports.entityTableColumn,
  json: exports.entityTableColumn,
  boolean: exports.entityTableBooleanColumn,
  count: exports.entityTableCountColumn,
  createdBy: exports.entityTableCreatedByColumn,
  updatedBy: exports.entityTableUpdatedByColumn,
  date: exports.entityTableDateColumn,
  datetime: exports.entityTableDateTimeColumn,
  entityReference: exports.entityReferenceColumn,
  entityReferenceMultiple: exports.entityReferenceColumn,
  dateRange: exports.entityTableDateColumn,
  datetimeRange: exports.entityTableDateTimeColumn,
  entityValue: exports.entityTableEntityValueColumn,
  relativeDate: exports.entityTableRelativeDateColumn,
  image: exports.entityTableImageColumn,
  info: exports.entityTableOpenGraphColumn,
  linkCount: exports.entityTableLinkCountColumn,
  linked: exports.entityTableLinkedColumn,
  linkedMultiple: exports.entityTableLinkedColumn,
  linkedTable: exports.entityTableLinkedColumn,
  banner: exports.entityTableLinkedColumn,
  longText: exports.entityTableContentColumn,
  description: exports.entityTableContentColumn,
  content: exports.entityTableContentColumn,
  summary: exports.entityTableContentColumn,
  name: exports.entityTableNameColumn,
  person: exports.entityTablePersonColumn,
  url: exports.entityTableColumn,
  hidden: exports.entityTableColumn,
  email: exports.entityTableColumn,
  float: exports.entityTableColumn,
  int: exports.entityTableColumn,
  nameHidden: exports.entityTableColumn,
  parent: exports.entityTableLinkedColumn,
  grantedPerson: exports.entityTablePersonColumn,
  permissions: exports.entityTableLinkedColumn,
  text: exports.entityTableColumn,
  color: exports.entityTableColorColumn,
  // todo add color column
  select: exports.entityTableColumn,
  textArea: exports.entityTableColumn,
  visibility: exports.entityTableLinkedColumn
};